import { IEnvironmentalVariable } from "stores/data/oceanWeatherIntelligences/oceanWeatherIntelligenceModel";
import {
  AlertTemplateConfigResponse,
  IOperationRuleAlert,
  IOperationRuleAlertForTable,
} from "../stores/data/insightAlerts/insightAlertModel";
import api from "./api";

export default class InsightAlertService {
  async getOperationRuleAlertForTable(
    operationRuleId?: number,
    operationRuleLocationId?: number,
    alertType?: string,
    operationRuleLocationItemIds?: number[]
  ): Promise<IOperationRuleAlertForTable[]> {
    const result = await api.post(
      `/v1/operationRuleAlert/getOperationRuleAlertForTable`,
      {
        operation_rule_id: operationRuleId,
        operation_rule_location_id: operationRuleLocationId,
        alert_type: alertType,
        operation_rule_location_item_ids: operationRuleLocationItemIds,
      }
    );
    if (result.status === 200) {
      return result.data;
    }
    throw new Error("Error while get operation rule alerts");
  }

  async getOperationRuleAlert(
    operationRuleAlertId: number
  ): Promise<IOperationRuleAlert> {
    const result = await api.post(
      `/v1/operationRuleAlert/getOperationRuleAlert`,
      {
        operation_rule_alert_id: operationRuleAlertId,
      }
    );
    if (result.status === 200) {
      return result.data;
    }
    throw new Error("Error while get operation rule alerts");
  }

  async deleteOperationRuleAlert(id: number): Promise<boolean> {
    const result = await api.delete(`/v1/operationRuleAlert/${id}`);
    if (result.status === 200 || result.status === 201) {
      return true;
    }
    throw new Error("Error while delete operation rule alert");
  }

  async updateOperationRuleAlert(
    operationRuleAlert: IOperationRuleAlert
  ): Promise<IOperationRuleAlert> {
    const result = await api.put(
      `/v1/OperationRuleAlert/${operationRuleAlert.id}`,
      {
        operationRuleAlert: operationRuleAlert,
      }
    );
    if (result.status === 200 || result.status === 201) {
      return result.data;
    }
    throw new Error("Error while update Alerts");
  }

  async setActive(
    operationRuleAlertId: number,
    isActive: boolean
  ): Promise<IOperationRuleAlert> {
    const result = await api.put(
      `/v1/OperationRuleAlert/${operationRuleAlertId}/set-active`,
      {
        active: isActive,
      }
    );
    if (result.status === 200 || result.status === 201) {
      return result.data;
    }
    throw new Error("Error while set active Alerts");
  }

  async addOperationRuleAlert(
    operationRuleAlert: IOperationRuleAlert
  ): Promise<IOperationRuleAlert> {
    const result = await api.post(`/v1/OperationRuleAlert`, {
      operationRuleAlert: operationRuleAlert,
    });
    if (result.status === 200 || result.status === 201) {
      return result.data;
    }
    throw new Error("Error while add Alert");
  }

  async getAlertTemplateConfig(): Promise<AlertTemplateConfigResponse> {
    const result = await api.get(`/v1/operationRuleAlert/alert-template-config`);

    if (result.status === 200) {
      return result.data;
    }
    throw new Error("Error while get alert template config");
  }

  async getEnvironmentalVariables(params: {
    macroRegionOrigin: string;
    stationId?: number;
    latitude?: number;
    longitude?: number;
  }): Promise<IEnvironmentalVariable[]> {
    const { macroRegionOrigin, stationId, latitude, longitude } = params;

    const queryParams: Record<string, string | number> = {
      macro_region_origin: macroRegionOrigin,
    };

    // Add stationId if it's an existing station (station_id > 0)
    if (stationId !== undefined && stationId > 0) {
      queryParams.station_id = stationId;
    }
    // Add lat/lon if it's a custom point (stationId === 0 or provided coordinates)
    else if (latitude !== undefined && longitude !== undefined) {
      queryParams.latitude = latitude;
      queryParams.longitude = longitude;
    }

    const result = await api.get(`/v1/operationRuleAlert/load-env-variables`, {
      params: queryParams,
    });

    if (result.status === 200) {
      return result.data;
    }
    throw new Error("Error while getting environmental variables");
  }

  async getSensorEnvironmentalVariables(params: {
    macroRegionOrigin: string;
  }): Promise<IEnvironmentalVariable[]> {
    const result = await api.get(`/v1/operationRuleAlert/load-sensor-env-variables`, {
      params: {
        macro_region_origin: params.macroRegionOrigin,
      },
    });

    if (result.status === 200) {
      return result.data;
    }
    throw new Error("Error while getting sensor environmental variables");
  }
}
